export default __webpack_public_path__ + "static/media/image-provider-photo.62bb1ca7.svg";